import script from "./WashCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WashCard.vue?vue&type=script&setup=true&lang=js"

import "./WashCard.vue?vue&type=style&index=0&id=12793b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12793b4c"]])

export default __exports__